<!-- <app-header></app-header>
<mc-card 
  heading="Un-Authorized Access!"
  subheading="Access Denied"
  body="You are not authorized to access this application, Please contact Administrator to get the access."
  variant="bordered"
  orientation="vertical"
  fit="medium"
>
  <div slot="actions" style="display:flex; justify-content: space-between;">
    <mc-button label="Action button" appearance="neutral" variant="filled" fit="medium"></mc-button>
    <mc-button icon="heart" appearance="neutral" variant="filled" hiddenlabel fit="medium"></mc-button>
  </div>
</mc-card> -->

<div style="margin:20px">
    <p style="font-size: 24px;">Un-Authorized Access!</p>
    <p>
        You are not authorized to access this application, Please contact the application administrator to get the access.</p>

</div>